import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import SimpleLoader from '../../../components/Loader/SimpleLoader';
import { getAllSchools } from '../../../services/catalog/catalog';
import { ExamYearContext } from '../../../utils/contexts/ExamYearContext';
import Select from '../../../components/forms/Select/Select';
import Table from '../../../components/Table/Table';
import useSchoolYearsColumns from './columns';
import SchoolYearsBulkActions from './SchoolYearsBulkActions';
import useSnackbar from '../../../utils/hooks/useSnackbar';

export default function SchoolYears() {
  const { yearList } = useContext(ExamYearContext);
  const [isLoading, setIsLoading] = useState(false);
  const [schools, setSchools] = useState([]);
  const [year, setYear] = useState([]);
  const [yearNot, setYearNot] = useState([]);
  const [selectedSchools, setSelectedSchools] = useState([]);
  const { addSnackbar } = useSnackbar();
  // Loading every page takes a while: drop an answer once a newer request has started
  const lastRequest = useRef(0);

  const getSchoolsData = useCallback(() => {
    const request = ++lastRequest.current;
    getAllSchools({ exam_year: year, exam_year_not: yearNot })
      .then((results) => {
        if (request !== lastRequest.current) return;
        setSchools(results.sort((a, b) => a.school_id - b.school_id));
        setSelectedSchools([]);
      })
      .catch(() => {
        if (request === lastRequest.current) addSnackbar('Не удалось загрузить школы', 'error');
      });
  }, [year, yearNot, addSnackbar]);

  useEffect(() => {
    getSchoolsData();
  }, [getSchoolsData]);


  const columns = useSchoolYearsColumns({ schools, selectedSchools, setSelectedSchools, yearList, getSchoolsData });

  return (
    <>
      {isLoading ? (
        <SimpleLoader className='h-10' />
      ) : (
        <>
          <div className='mb-8 mr-8 flex flex-row gap-4'>
            <Select
              value={year}
              isClearable
              label='Год'
              onChange={(v) => setYear(v?.value)}
              options={yearList.map((y) => ({
                value: y.uuid,
                label: y.year,
              }))}
            />
            <Select
              value={yearNot}
              isClearable
              label='Не год'
              onChange={(v) => setYearNot(v?.value)}
              options={yearList.map((y) => ({
                value: y.uuid,
                label: y.year,
              }))}
            />
          </div>
          <SchoolYearsBulkActions
            selectedSchools={selectedSchools}
            setSelectedSchools={setSelectedSchools}
            yearList={yearList}
            onDone={getSchoolsData}
          />
          <Table
            columns={columns}
            data={schools}
            loading={isLoading}
            showAllRows
          />
        </>
      )}
    </>
  );
}
